import React from "react";
import { Link } from "react-router-dom";

// Hub "Quản lý dạy học" — gom các danh mục nền phục vụ xếp thời khoá biểu.
const ITEMS = [
  { to: "/happyschool/teachers", icon: "👩‍🏫", label: "Giáo viên", desc: "Chỉ hiện nhân sự thuộc Khối Giáo viên THPT — thêm/sửa/xoá, nhập/xuất Excel." },
  { to: "/happyschool/subjects", icon: "📚", label: "Môn học", desc: "Danh mục môn học và số tiết liền khối mỗi buổi." },
  { to: "/happyschool/class-list", icon: "🏫", label: "Lớp học", desc: "Danh sách lớp, Loại lớp, Tổ hợp — thêm/sửa/xoá, nhập/xuất Excel." },
  { to: "/happyschool/classes", icon: "🧑‍🏫", label: "Phân công chuyên môn", desc: "Ma trận Lớp × Môn — gán giáo viên phụ trách và số tiết/tuần cho từng lớp." },
  { to: "/happyschool/pccm-draft", icon: "📝", label: "Soạn thảo PCCM (nháp)", desc: "Ma trận Lớp × Môn để thử phân công GV — bản nháp độc lập, không ảnh hưởng tới dữ liệu xếp TKB." },
  { to: "/happyschool/pccm-history", icon: "🕓", label: "Lịch sử PCCM", desc: "Các bản chụp PCCM thật — tự lưu mỗi khi Duyệt bản nháp hoặc xếp TKB, tra lại TKB cũ đã dùng PCCM nào." },
  { to: "/happyschool/period-rules", icon: "🔢", label: "Số tiết", desc: "Quy định số tiết/tuần mỗi môn (CK/TC/CĐ) theo Lớp chọn/thường × Khối × Học kỳ; áp dụng vào các lớp." },
  { to: "/happyschool/combinations", icon: "🧩", label: "Tổ hợp bộ môn", desc: "Định nghĩa các tổ hợp môn học, gán cho từng lớp ở trang Lớp học." },
  { to: "/happyschool/combination-teachers/tunhien", icon: "🧪", label: "Giáo viên tổ hợp tự nhiên", desc: "GV đang dạy các môn thuộc nhóm Tự nhiên (gán ở trang Tổ hợp bộ môn)." },
  { to: "/happyschool/combination-teachers/xahoi", icon: "🌍", label: "Giáo viên tổ hợp xã hội", desc: "GV đang dạy các môn thuộc nhóm Xã hội (gán ở trang Tổ hợp bộ môn)." },
  { to: "/happyschool/homeroom-teachers", icon: "🧑‍🎓", label: "Giáo viên chủ nhiệm", desc: "GV chủ nhiệm, SĐT, lớp chủ nhiệm, SĐT lớp trưởng/lớp phó." },
];

const HappySchoolTeachingHub = () => (
  <div style={{ padding: 24 }}>
    <h2 style={{ margin: "0 0 4px" }}>🧑‍🏫 Quản lý dạy học</h2>
    <p style={{ color: "#6b7280", fontSize: 13, marginTop: 0 }}>
      Các danh mục nền phục vụ giảng dạy và xếp thời khoá biểu. Bấm vào để mở.
    </p>
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))", gap: 12, marginTop: 16 }}>
      {ITEMS.map((it) => (
        <Link key={it.to} to={it.to} style={cardStyle} className="hs-teach-card">
          <span style={{ fontSize: 26 }}>{it.icon}</span>
          <div style={{ textAlign: "left" }}>
            <div style={{ fontWeight: 600, color: "#1f2937" }}>{it.label}</div>
            <div style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.4 }}>{it.desc}</div>
          </div>
        </Link>
      ))}
    </div>
    <style>{`.hs-teach-card:hover{ border-color:#0ea5a3; background:#f0fdfa; transform:translateY(-1px); }`}</style>
  </div>
);

const cardStyle = {
  display: "flex", alignItems: "flex-start", gap: 12, padding: 14, border: "1px solid #e5e7eb",
  borderRadius: 10, background: "#fff", textDecoration: "none", color: "inherit", transition: "all .15s",
  boxShadow: "0 1px 2px rgba(0,0,0,.04)", textAlign: "left",
};

export default HappySchoolTeachingHub;
